import * as types from './types';
import * as api from '../utilities/api';
import { concatStudentNames } from '../utilities/common';


/*
 * action creators
 */
window.addEventListener("message", (e) => {
    var data = e.data; // hare are data sent by other window postMessage method
    localStorage.setItem('recordId', data);
    // console.log(data);
});
// console.log(localStorage.getItem('contentparams'));
let contentparams = JSON.parse(localStorage.getItem('contentparams'));
console.log(contentparams);

/** setCaptionsFlag is a redux action that runs when the caption button is clicked
 * @Param: true, false (enabled/disabled)
 * @Usage: Whenever the captions button is clicked
 */

export function setCaptionsFlag(flag, users) {
    return { type: types.SET_CAPTIONS_FLAG, flag, users };
}


/** setPauseFlag is a redux action that runs when pause, play, next page
 * @Param: true, false, null (paused, playing, blocked)
 * @Usage: Whenever the pause/play button is clicked
 */


export function setPauseFlag(flag, users) {
    return { type: types.SET_PAUSE_FLAG, flag, users };
}

/** saveAnswer is a redux action that saves a variable into the redux store
 * @Param: studentInput: "{"TotalResistance":"14"}"   //string, variable name and value
 * @Usage: Any time we save a variable
 */
export function saveAnswers(answers, users) {
    // console.log('action');
    // console.log(answer);
    return { type: types.SAVE_ANSWERS, answers, users };
}


/** saveAnswer is a redux action that saves a variable into the redux store
 * @Param: studentInput: "{"TotalResistance":"14"}", string, variable name and value
 * @Usage: Any time we save a variable
*/
export function saveAnswer(answer, users) {
    return { type: types.SAVE_ANSWER, answer, users };
}

export function setAnswers(answers) {
    return { type: types.SET_ANSWERS, answers };
}

// Login Redux Action
// After login, user info is saved into the redux store
export function login(studentId, studentId1) {
    return dispatch => {
        return api.postLoginData(studentId, studentId1).then(response => {
            // console.log(response);
            localStorage.setItem('jwtToken', response.token);
            //api.setAuthorizationToken(response.token);
            dispatch(setCurrentUsers(response.users, response.user));
            return response;
        });
    };
}
// Sample Return Payload
// {
//     "token": "1-2-3",
//     "user": { /* the user that was just logged in */
//     "created_at": "2018-10-25T12:38:31",
//         "first_name": "bob",
//         "id": 1,
//         "last_name": "joe",
//         "role": "student",
//         "updated_at": "2019-03-22T17:31:11",
//         "username": "a3"
// },
//     "users": [ /* a list of the users currently logged in */
//     0: {
//     "created_at": "2018-10-25T12:38:31",
//         "first_name": "bob",
//         "id": 1,
//         "last_name": "joe",
//         "role": "student",
//         "updated_at": "2019-03-22T17:32:17",
//         "username": "a3"
// }
// ]
// }


// ------------------------------------------ //

// Set token for back-end authorization
export function setjwtToken(token) {
    localStorage.setItem('jwtToken', token);
}

// Get all users currently logged in
export const getCurrentUsers = () => (
    dispatch => api.getCurrentUsers(contentparams).then(response => {
        const loggedInUsers = response.users;
        const user = loggedInUsers[0];
        dispatch(setCurrentUsers(loggedInUsers, user));
    })
);

// Set all currently logged in users
export function setCurrentUsers(users, user = {}) {
    return {
        type: types.SET_CURRENT_USERS,
        user,
        users
    };
}


export const fetchMyAssignment = (recordId) => (
    dispatch => api.fetchMyAssignment(recordId, JSON.parse(localStorage.getItem('contentparams'))).then(response => {
        // console.log('dispatch');
        // console.log(response);

        const progress = response.assignment.progress || {};
        const userId = Object.keys(progress)[0];
        const feedback = userId ? progress[userId].feedback : null;
        localStorage.setItem('feedback', JSON.stringify(feedback));
        // console.log(feedback);
        const userValue = concatStudentNames(response.assignment.users);
        localStorage.setItem('userName', userValue);
        // console.log(userValue)

        const { preAssessments = [], postAssessments = [] } = response.assignment;
        dispatch(setCurrentMyAssignment(recordId, {
            ...response.assignment,
            preAssessments: preAssessments.map(assessment => ({
                ...assessment
            })),
            postAssessments: postAssessments.map(assessment => ({
                ...assessment
            })),
        }));
        return response;
    })
);


export const setCurrentMyAssignment = (recordId, recordData) => ({
    type: types.SET_CURRENT_MY_ASSIGNMENT,
    recordId,
    recordData,
    users: recordData.users
});


export function addFlashMessage(message, msgType = 'error', statusCode) {
    return {
        type: types.ADD_FLASH_MESSAGE,
        msgType,
        message,
        statusCode,
    };
}

export const clearFlashMessage = () => ({
    type: types.CLEAR_FLASH_MESSAGE,
});



// WEBPACK FOOTER //
// ./src/js/actions/jre.js